import axios from "axios";

const api = axios.create({
    baseURL: 'https://configsite.crivelli.com.br/api/',
    // baseURL: 'https://localhost:44397/api/'
})


export default api;